import searchFill from '@iconify/icons-eva/search-fill';
import add from '@iconify/icons-ic/add';
import { Icon } from '@iconify/react';
import { useState, useCallback } from 'react';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import {
  Autocomplete,
  Box,
  Grid,
  IconButton,
  InputAdornment,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { DateRangeStyled, RootStyle, SearchStyle } from '../Global/Styling';
// ---------------------------------------------------------
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { fDate } from '../../utils/formatTime';
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';

export default function DataToolbar({
  filterName,
  setFilterName,
  parent,
  filterDatesRange,
  setFilterDatesRange,
  selectStatus,
  selectStatusValue,
  setSelectStatusValue,
  setFilterParameter,
  filterParameter,
  rowInfo,
  onValidateClick,
  handleExport
}) {
  const navigate = useNavigate();
  const [isOpenFilter, openFilter] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { BankDrop } = useGlobalSelector();
  const handleOpen = useCallback((e) => setAnchorEl(e.currentTarget), []);
  const handleClose = useCallback(() => setAnchorEl(null), []);

  const handleRemoveFilter = useCallback(() => {
    setFilterDatesRange([
      {
        startDate: null,
        endDate: null,
        key: 'selection'
      }
    ]);
    setSelectStatusValue(' ');
    setFilterName('');
    setFilterParameter({
      bankId: null
    });
  }, [setFilterDatesRange, setSelectStatusValue, setFilterName, setFilterParameter]);

  const onFilterName = useCallback(
    (event) => {
      setFilterName(event.target.value);
    },
    [setFilterName]
  );

  return (
    <>
      {isOpenFilter && (
        <Box px={3} pt={2}>
          <Grid container spacing={3}>
            <Grid item xs>
              <Autocomplete
                disablePortal
                id="combo-box-demo8"
                options={BankDrop || []}
                size="small"
                getOptionLabel={(option) => option.label}
                renderOption={(props, option) => <li {...props}>{option.label}</li>}
                renderInput={(params) => (
                  <TextField {...params} fullWidth placeholder="Select Bank Name" />
                )}
                value={BankDrop?.find((item) => item.value === filterParameter?.bankId) || null}
                onChange={(e, newValue) => {
                  setFilterParameter((pre) => ({
                    ...pre,
                    bankId: newValue?.value
                  }));
                }}
              />
            </Grid>
            <Grid item xs sx={{ position: 'relative' }}>
              <Box className="displayDateRange">
                {filterDatesRange[0].startDate !== null
                  ? `${fDate(filterDatesRange[0].startDate)} to `
                  : ''}
                {filterDatesRange[0].endDate !== null ? fDate(filterDatesRange[0].endDate) : ''}
                {filterDatesRange[0].startDate === null && filterDatesRange[0].endDate === null ? (
                  <Typography className="dissabledMenu">Select Date Range</Typography>
                ) : (
                  ''
                )}
              </Box>
              <Select
                fullWidth
                inputProps={{
                  className: 'textInput'
                }}
                MenuProps={{
                  className: 'menuOpened'
                }}
                value=" "
                className="datesSelect"
              >
                <DateRangeStyled
                  editableDateInputs={false}
                  onChange={(item) => setFilterDatesRange([item.selection])}
                  moveRangeOnFirstSelection={false}
                  ranges={filterDatesRange}
                  className="dateRangePicker"
                />
              </Select>
            </Grid>
            <Grid item xs>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${selectStatusValue}`
                }}
                value={selectStatusValue}
                onChange={(e) => {
                  setSelectStatusValue(e.target.value);
                }}
              >
                <MenuItem value=" " disabled>
                  Select Status
                </MenuItem>
                <MenuItem value={selectStatus.ACTIVE.type_id}>Active</MenuItem>;
                <MenuItem value={selectStatus.INACTIVE.type_id}>Inactive</MenuItem>;
                <MenuItem value={selectStatus.INCOMPLETE.type_id}>Incomplete</MenuItem>;
              </Select>
            </Grid>
            <Grid item xs="auto">
              <Tooltip title="Reset Filter">
                <IconButton onClick={(e) => handleRemoveFilter(e)} size="small">
                  <FilterListOffIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      )}

      <RootStyle
        sx={{
          minHeight: 45,
          borderBottom: '1px solid #eaedf1'
        }}
      >
        <Box>
          <Tooltip title="Add Data Source" placement="top" arrow>
            <IconButton
              className="squareIconButton"
              onClick={(e) => {
                localStorage.removeItem('reviewData');
                localStorage.removeItem('commisssionType');
                navigate(`/${parent}/add`);
              }}
            >
              <Icon icon={add} width={18} />
            </IconButton>
          </Tooltip>
          &nbsp; &nbsp;
          <Tooltip title="Validate Details" placement="top" arrow>
            <IconButton
              className="squareIconButton"
              onClick={() => onValidateClick(rowInfo?.[0]?.id)}
              disabled={rowInfo?.length !== 1}
            >
              <Icon icon="material-symbols:verified-outline" width={18} />
            </IconButton>
          </Tooltip>
          &nbsp; &nbsp;
          <Tooltip title="Check Bureau" placement="top" arrow>
            <IconButton
              className="squareIconButton"
              onClick={(e) => {
                localStorage.removeItem('reviewData');
                localStorage.removeItem('commisssionType');
                navigate(`/${parent}/check-bureau`);
              }}
            >
              <Icon icon="material-symbols:fact-check-rounded" width={18} />
            </IconButton>
          </Tooltip>
          &nbsp; &nbsp;
          <Tooltip title="Export" placement="top" arrow>
            <IconButton
              className="squareIconButton"
              size="small"
              sx={{ p: 0.1 }}
              onClick={handleOpen}
            >
              <Icon icon="mdi:export-variant" width={18} />
            </IconButton>
          </Tooltip>
          &nbsp; &nbsp;
          <Tooltip title="Allocation" placement="top" arrow>
            <span>
              <IconButton
                className="squareIconButton"
                disabled={rowInfo?.length !== 1}
                onClick={() => {
                  localStorage.removeItem('reviewData');
                  localStorage.removeItem('commisssionType');
                  navigate(`/${parent}/allocation`, {
                    state: {
                      rowId: rowInfo?.[0]?.id
                    }
                  });
                }}
              >
                <Icon icon="material-symbols:assignment-ind" width={18} />
              </IconButton>
            </span>
          </Tooltip>
          <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
            <MenuItem onClick={() => handleExport('EXCEL')}>
              <ListItemIcon>
                <CheckCircleIcon color="success" fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Export as Excel" />
            </MenuItem>

            <MenuItem onClick={() => handleExport('PDF')}>
              <ListItemIcon>
                <CancelIcon color="error" fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Export as PDF" />
            </MenuItem>
          </Menu>
        </Box>
        <Box>
          <SearchStyle
            value={filterName}
            onChange={onFilterName}
            placeholder="Search Data Source"
            classes={{
              root: 'searchHolder',
              input: 'searchInput'
            }}
            startAdornment={
              <InputAdornment position="start">
                <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            }
          />
          &nbsp;&nbsp;&nbsp;
        </Box>
      </RootStyle>
    </>
  );
}
